module.exports = __webpack_public_path__ + "img/employees.faa72bee.svg";